import type { EntityName } from '../types/entities';

export type AppConfig = {
  spreadsheetId?: string;
  serviceAccountEmail?: string;
  privateKey?: string;
  syncEntities: EntityName[];
  syncMode: 'mock' | 'live';
  updatedSince?: string;
  mockDataPath: string;
  logLevel: 'debug' | 'info' | 'warn' | 'error';
};

export function loadConfig(env: Record<string, string | undefined> = process.env): AppConfig {
  const rawEntities = env.SYNC_ENTITIES || 'orders,customers,invoices';
  const syncEntities = rawEntities.split(',').map((item) => item.trim()).filter(Boolean) as EntityName[];

  return {
    spreadsheetId: env.GOOGLE_SHEETS_SPREADSHEET_ID,
    serviceAccountEmail: env.GOOGLE_SERVICE_ACCOUNT_EMAIL,
    privateKey: env.GOOGLE_PRIVATE_KEY?.replace(/\\n/g, '\n'),
    syncEntities,
    syncMode: env.SYNC_MODE === 'live' ? 'live' : 'mock',
    updatedSince: env.SYNC_UPDATED_SINCE,
    mockDataPath: env.MOCK_DATA_PATH || './src/mock-data',
    logLevel: (env.LOG_LEVEL as AppConfig['logLevel']) || 'info',
  };
}
